import React from "react";
import { MessageBox } from "capitalrx-components";

interface ResponseDURMessage {
  durFreeTextMessage: string;
  durAdditionalText?: string;
  reasonForServiceCode?: string;
  clinicalSignificanceCode?: string;
  otherPharmacyIndicator?: string;
  previousDateOfFill?: string;
  quantityOfPreviousFill?: number;
  databaseIndicator?: string;
  otherPrescriberIndicator?: string;
}

const DURMessageComponent: React.FC<ResponseDURMessage> = (props: ResponseDURMessage) => {
  const {
    durFreeTextMessage,
    durAdditionalText,
    reasonForServiceCode,
    clinicalSignificanceCode,
    previousDateOfFill,
    quantityOfPreviousFill,
    otherPrescriberIndicator,
    otherPharmacyIndicator,
    databaseIndicator,
  } = props;

  const durFullText = `${durFreeTextMessage}; ${durAdditionalText}`;

  const durFieldsContent = (
    <div className="dur-fields-content">
      <div className="row">
        <div className="col dur-field-labels">Database Indicator:</div>
        <div className="col">{databaseIndicator}</div>
      </div>
      <div className="row">
        <div className="col dur-field-labels">Previous Fill Date:</div>
        <div className="col">{previousDateOfFill}</div>
      </div>
      <div className="row">
        <div className="col dur-field-labels">Quantity of Previous Fill:</div>
        <div className="col">{quantityOfPreviousFill}</div>
      </div>
      <div className="row">
        <div className="col dur-field-labels">Reason For Service Code:</div>
        <div className="col">{reasonForServiceCode}</div>
      </div>
      <div className="row">
        <div className="col dur-field-labels">Clinical Significance Code:</div>
        <div className="col">{clinicalSignificanceCode}</div>
      </div>
      <div className="row">
        <div className="col dur-field-labels">Other Pharmacy Indicator:</div>
        <div className="col">{otherPharmacyIndicator}</div>
      </div>
      <div className="row">
        <div className="col dur-field-labels">Other Prescriber Indicator:</div>
        <div className="col">{otherPrescriberIndicator}</div>
      </div>
    </div>
  );

  let DURComponent: JSX.Element = null;

  if (durFreeTextMessage) {
    DURComponent = (
      <MessageBox message={durFullText} type="warning" shadow={false}>
        {durFieldsContent}
      </MessageBox>
    );
  }

  return DURComponent;
};

export default DURMessageComponent;
